import { useState } from "react";

import { archiveAttributes, archiveComponents } from "../../../api/trash";
import { getFilteredAttributes, getFilteredComponents, handleSelected } from "./helpers";

export const useDeleteComponentsAndAttributes = ({
  ideas,
  data,
  initialModalOpen,
  getComponentsData,
  projectId,
  setModalOpen,
}) => {
  const [selectedComponents, setSelectedComponents] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [warningData, setWarningData] = useState(null);
  const [lengthArchivedComponents, setlengthArchivedComponents] = useState();
  const [lengthArchivedAttributes, setlengthArchivedAttributes] = useState();

  const handleSelectedComponents = (componentId) => {
    setSelectedComponents((prev) => handleSelected(prev, componentId));
  };

  const handleSelectedAttributes = (attributeId) => {
    setSelectedAttributes((prev) => handleSelected(prev, attributeId));
  };

  const deleteSelectedComponentsAndAttributes = async () => {
    const onSuccess = () => {
      getComponentsData(projectId);
    };

    selectedComponents?.length &&
      (await archiveComponents(
        {
          componentIds: selectedComponents,
          teamId: data.product.teamId || "",
          productId: data.product.id,
        },
        ({ trashFull, lengthArchivedComponents }) => {
          if (trashFull) {
            setModalOpen({ ...initialModalOpen, deleteComponents: true });
            setlengthArchivedComponents(lengthArchivedComponents);
          } else {
            onSuccess();
          }
        },
      ));

    selectedAttributes?.length &&
      (await archiveAttributes(
        {
          attributeIds: selectedAttributes,
          teamId: data.product.teamId || "",
          productId: data.product.id,
        },
        ({ trashFull, lengthArchivedAttributes }) => {
          if (trashFull) {
            setModalOpen({ ...initialModalOpen, deleteAttributes: true });
            setlengthArchivedAttributes(lengthArchivedAttributes);
          } else {
            onSuccess();
          }
        },
      ));

    setWarningData(null);
  };

  const showWarningForDeletingComponentsAndAttributes = () => {
    const componentsWithIdeas = getFilteredComponents(ideas, data, selectedComponents);
    const attributesWithIdeas = getFilteredAttributes(ideas, data.attributes, selectedAttributes);

    if (!attributesWithIdeas?.length && !componentsWithIdeas.length) {
      return false;
    }

    setWarningData({ attributesWithIdeas, componentsWithIdeas, components: data.components });
  };

  return {
    selectedAttributes,
    selectedComponents,

    handleSelectedAttributes,
    handleSelectedComponents,

    deleteSelectedComponentsAndAttributes,

    lengthArchivedComponents,
    lengthArchivedAttributes,

    setlengthArchivedComponents,
    setlengthArchivedAttributes,

    warningData,
    showWarningForDeletingComponentsAndAttributes,
    setWarningData,
  };
};
